const parseCookie = (key) => {
  if (!document.cookie) {
    return null;
  }
  const reg = new RegExp(`(?:^|\\s)${key}=([^;\\s]*)`);
  const match = document.cookie.match(reg);
  return match?.[1] && match.length === 2 ? decodeURIComponent(match[1]) : null;
};
const setCookie = (key, value, expireDays) => {
  if (!location.host) {
    return;
  }
  let domainValue = "";
  const domainParts = location.host.split(".");
  if (domainParts.length === 2) {
    domainValue = `.${location.host}`;
  } else if (domainParts.length > 2) {
    domainParts.shift();
    domainValue = `.${domainParts.join(".")}`;
  }
  const expireDate = new Date(Date.now() + expireDays * 24 * 60 * 60 * 1e3);
  const cookieStr = `${key}=${encodeURIComponent(value)};path=/;expires=${expireDate.toUTCString()};`;
  document.cookie = `${cookieStr}domain=${domainValue}`;
  if (!parseCookie(key)) {
    document.cookie = `${cookieStr}domain=.${location.host}`;
  }
};
export {
  parseCookie,
  setCookie
};
